import AddInIds from "./AddInIds";

export const PAGE_CONFIGS = {
  diagnosticMonitor: {
    addInId: AddInIds.statusMonitorTableSetting,
    persistAttributes: [
      "columnNames",
      "colorIntervals",
      "hideOldData",
      "includeDismissedWarnings",
      "deviceCountLimit",
      "loadAddresses",
      "chargeRateOnlyWhenCharging",
    ],
  },
  statusMonitor: {
    addInId: AddInIds.deviceStatusDataTableSettings,
    persistAttributes: [
      "columnNames",
      "colorIntervals",
      "hideOldData",
      "includeDismissedWarnings",
      "deviceCountLimit",
      "loadAddresses",
      "chargeRateOnlyWhenCharging",
    ],
  },
  faultMonitor: {
    addInId: AddInIds.faultColumnSettings,
    persistAttributes: [],
  },
  deviceFirmware: {
    addInId: AddInIds.deviceFirmwareTableSettings,
    persistAttributes: ["columnNames", "deviceCountLimit"],
  },
  maintenance: {
    addInId: AddInIds.maintenanceSettings,
  },
} as const;

export type PageType = keyof typeof PAGE_CONFIGS;
